// Template Library Action Types
export const OPEN_TEMPLATE_LIBRARY = 'OPEN_TEMPLATE_LIBRARY';
export const CLOSE_TEMPLATE_LIBRARY = 'CLOSE_TEMPLATE_LIBRARY';
export const SELECT_CATEGORY = 'SELECT_CATEGORY';
export const SEARCH_TEMPLATES = 'SEARCH_TEMPLATES';
export const CLEAR_SEARCH = 'CLEAR_SEARCH';
export const SET_VIEW_MODE = 'SET_VIEW_MODE';
export const LOAD_TEMPLATES_SUCCESS = 'LOAD_TEMPLATES_SUCCESS';
export const LOAD_CATEGORIES_SUCCESS = 'LOAD_CATEGORIES_SUCCESS';
export const APPLY_TEMPLATE = 'APPLY_TEMPLATE';
